<template>
    <div class="md-evaluation-banner classic">
        <banner
            :type="type"
            :mobileType="mobileType"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :pictureListOption="pictureListOption"
            :maskOption="maskOption"
        >
            <div
                class="cover f-col"
                :style="{ paddingBottom: marginBottom }"
            >
                <!-- title  Displayed only when the content is the first or second step and it is not a mobile phone  -->
                <div :class="[ 'main-title', { step1: step == 1, step2: step == 2 } ]" v-if="title && (step == 0 || (step == 1 && !isMobile))" v-html="formatFontSize(title, 38)" style="font-family:var(--mg-title-font)"></div>
                <!-- description  Displayed only when the content is the first or second step and it is not a mobile phone  -->
                <div :class="[ 'description', { step1: step == 1, step2: step == 2 } ]" v-if="description && (step == 0 || (step == 1 && !isMobile))" v-html="formatFontSize(description, 24)" style="font-family:var(--font-normal)"></div>
                <div class="slide-switch">
                    <div class="slide" v-if="step == 0">
                        <address-input
                            @submitAddress="submitAddress"
                            :addressHeaderContent="instruction"
                            :showUnitField="showUnitField"
                            :addressInputStyle="addressInputStyle"
                            :placeholder="placeholder"
                            :submitText="submitText"
                            :submitStyle="submitStyle"
                        />
                    </div>
                    <div class="slide" v-if="step == 1">
                        <evaluation-register
                            v-bind="register"
                            type="register"
                            :options="registerOption"
                            :address="address || defaultAddress"
                            :unit="unit"
                            @loaded="registerMounted"
                            @registerSuccess="registerSuccess"
                        />
                    </div>
                    <div class="slide" v-if="step == 2">
                        <component
                            :is="evaluationReportName"
                            :ref="onRef"
                            :address="address || defaultAddress"
                            :unit="unit"
                            @loaded="reportMounted"
                            @report="getReport"
                            :useZillow="reportUseZillow"
                            :panelBackground="panelBackground"
                            :agentId="agentId"
                            :showReport="showReport"
                            :isSkipStep2="isSkipStep2"
                            :report="report"
                            :agentHtml="agentHtml"
                        />
                        <NearbyListings
                            :comparableList="comparableList"
                            :reportJSON="reportJSON"
                            :more="{
                                bgColor: report.priceTitleColor,
                                link: moreLink
                            }"
                        />
                    </div>
                </div>

                <evaluation-progress
                    v-show="!homeReportInfo.id"
                    :step="step"
                    :isSkipStep2="isSkipStep2"
                    icon-theme="classic"
                    :simpleMode="simpleMode"
                    :stepIconColor="stepIconColor"
                    :showCopyright="shouldShowCopyright"
                    :class="{ step1: step == 1, step2: step == 2 }"
                />
            </div>
            <div v-if="!isMobile" class="f-col">
                <div v-if="copyrightHtml" v-html="copyrightHtml"></div>
                <copy-right
                    :chimeHtml="chimeHtml"
                    :chimeText="cmpChimeText"
                    :chimeLink="chimeLink"
                    :showCopyright="shouldShowCopyright"
                />
            </div>
        </banner>
        <div v-if="isMobile">
            <div v-if="copyrightHtml" v-html="copyrightHtml"></div>
            <copy-right
                :chimeHtml="chimeHtml"
                :chimeText="cmpChimeText"
                :chimeLink="chimeLink"
                :showCopyright="shouldShowCopyright"
            />
        </div>
        <Subscribe v-if="isShowSubscribe" />
    </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import common from '../index';
import evaluationRegister from './evaluation-register.vue';
import evaluationProgress from '../evaluation-progress.vue';
import NearbyListings from '../nearbyListings.vue';

export default {
    mixins: [common],
    components: {
        evaluationRegister,
        evaluationReportWeb: defineAsyncComponent(() => import(/* webpackChunkName: "evaluation-report-web-classic"*/ './evaluation-report-web.vue')),
        evaluationReportMobile: defineAsyncComponent(() => import(/* webpackChunkName: "evaluation-report-mobile-classic"*/ './evaluation-report-mobile.vue')),
        NearbyListings,
        evaluationProgress
    },
    data: function() {
        return {
           
            reportHistory: [],
            agentId: 0,
            panelBackground: {
                topBackground: '',
                bottomBackground: ''
            }
        };
    },
    methods: {
        //  avoid  loading  Pop-ups
        registerSuccess() {
            this.step = 2;
        },
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-evaluation-banner.classic {
    .banner {
        position: relative;
        padding: 0;
        flex-direction: column;
        @include adapter((padding-top, 80px, 50px));
        .cover {
            flex-direction: column;
            position: relative;
            z-index: 2;
            align-self: center;
            text-align: center;
            .main-title {
                font-size: 38px;
                line-height: 1.34;
                padding: 40px 0 10px;
                font-family: var(--font-bold);
                @include webkitBox(4);
            }
            .description {
                padding-bottom: 48px;
                font-size: 24px;
                font-family: var(--font-normal);
                @include webkitBox(4);
                &.step1 {
                    padding-bottom: 21px;
                }
            }
            .slide-switch {
                width: 100%;
                flex: none;
                display: flex;
                justify-content: center;
                .slide {
                    width: 100%;
                    .address-input.gf {
                        max-width: 100%;
                        .address-body input {
                            border-radius: 0;
                            color: #4a4a60;

                            &::placeholder {
                                font-size: 14px;
                                color: #8b93a7;
                            }
                            &:focus {
                                box-shadow: none;
                            }
                        }
                        .icon-search-close:before {
                            font-size: 20px;
                        }
                        .submit-btn {
                            @include color-button-hover();
                            @include color-button();
                            box-shadow: none;
                            border: none;
                            border-radius: 0;
                            font-weight: 500;
                        }
                    }
                    .address-header {
                        margin: 10px 0 18px;
                    }
                }
            }
            //  progress style
            .md-evaluation-banner {
                .md-evaluation-steps-content {
                    // border-top: 1px solid rgba(255, 255, 255, 0.4);
                    @include adapter((padding, 60px 0 60px, 40px 0 60px));
                }
                &.step1 .md-evaluation-steps-content {
                    padding-top: 30px;
                }
            }
            .gf-loading,
            .gf-loading-sec {
                font-size: 22px;
                line-height: 28px;
                color: #600;
                margin: 0 auto;
                width: 66%;
                background-color: white;
                border-radius: 4px;
                text-align: center;
                box-shadow: 2px 2px 2px #7f7f7e;
                padding: 15px;
                font-size: 22px;
                margin-bottom: 15px;
            }
        }
        .f-col {
            z-index: 3;
        }
        .copyright {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 9;
        }
        .comparable-listing {
            text-align: left;

            .comparable-listing-title {
                font-size: 24px;
                line-height: 1.67;
                color: #fff;
                text-align: center;
                margin-top: 80px;
                margin-bottom: 30px;
            }
            .house-grid.template4.full-screen .house-grid-item {
                @include adapter((width, calc((100% - 60px) / 3), 100%));
            }
            .house-grid.template4 {
                @include adapter((width, calc(100% + 30px), 100%));
            }
            .more-listing {
                text-align: center;
                a {
                    display: inline-block;
                    width: 340px;
                    height: 40px;
                    @include adapter((width, 340px, 100%));
                    background-color: var(--color-theme);
                    color: #fff;
                    margin: 15px auto;
                    border-radius: 5px;
                    font-size: 14px;
                    line-height: 40px;
                    cursor: pointer;
                }
            }
        }
    }
}
@include media-800 {
    .md-evaluation-banner.classic {
        .banner {
            .cover {
                max-width: 100%;
                padding: 0px 15px 0;
                .main-title {
                    font-size: 24px;
                    line-height: 1.58;
                    padding: 0 0 10px;
                }
                .description {
                    padding-bottom: 76px;
                    font-size: 16px;
                }
                .gf-loading,
                .gf-loading-sec {
                    width: 716px;
                    max-width: 92%;
                    margin-top: 20px;
                }
            }
        }
    }
}
</style>
